import Burger from './burger'
import { countNodes } from 'Utils/countNodes'

const mobileMenu = document.querySelector('#mobile-menu')
const header = document.querySelector('#header')

function toggleMobileMenu(state, event) {
	if (state == 'opened'){
		mobileMenu.classList.remove('mob-menu-hidden');
		mobileMenu.classList.add('opened');
		document.body.classList.add('opened');
	}
	else{
		mobileMenu.addEventListener('transitionend', () => mobileMenu.classList.add('mob-menu-hidden'), { once: true })
		mobileMenu.classList.remove('opened');
		document.body.classList.remove('opened');
		mobileMenu.querySelectorAll('.sub-menu.active').forEach(el => el.classList.remove('active'));
	}
}

function setMobMenuOffset(){
	mobileMenu.style.setProperty('--mob-menu-offset', `${header.clientHeight}px`)
}
window.addEventListener('resize', setMobMenuOffset)
document.addEventListener('DOMContentLoaded', setMobMenuOffset)

const headerBurgerContainer = document.querySelector('#header-burger')
const headerBurger = new Burger(headerBurgerContainer)
headerBurger.addAction(toggleMobileMenu)



const logNodes = () => console.log(countNodes())

// logNodes()
// window.addEventListener('load',() => {
// 	setTimeout(logNodes, 1000)
// })